var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm._value,"z-index":"99999"}},[_c('v-progress-circular',{attrs:{"color":_vm.color,"size":_vm.size,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }